<template>
  <div class="draggable-topics-container">
    <div class="header" style="display: none;">
      <h1>📋 Telegram Draggable Forum Topics</h1>
      <p>Перетаскивайте топики и сохраняйте их позиции</p>
    </div>

    <div class="controls" style="display: none;">
      <input
        type="file"
        ref="fileInput"
        @change="loadJsonFiles"
        multiple
        accept=".json"
        style="display: none;"
      >
      <button class="btn" @click="$refs.fileInput.click()">
        📁 Загрузить JSON файлы
      </button>
      <button class="btn" @click="resetPositions" :disabled="topics.length === 0">
        🔄 Сбросить позиции
      </button>
      <button class="btn" @click="exportPositions" :disabled="topics.length === 0">
        💾 Экспорт позиций
      </button>
    </div>

    <div v-if="loading" class="loading">
      Загрузка файлов...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>

    <div class="workspace-wrapper">
      <div
        class="workspace"
        ref="workspace"
      >

        <div
          v-for="category in categories.filter((category) => category.title === 'В Работе')"
          :key="category.cat_id"
          class="category-container uncategorized-topics"
          style="margin-top: 0"
          :class="{ 'drop-zone-active': dragOverCategory === category.cat_id }"
          @dragover.prevent="handleDragOver(category.cat_id)"
          @dragleave="handleDragLeave"
          @drop="handleDrop(category.cat_id)"
        >
          <div class="category-header">
            <input
              v-model="category.title"
              class="category-title"
              :placeholder="`Категория ${category.cat_id}`"
              @blur="saveCategories"
            />
            <span class="category-count">{{ getCategoryTopics(category.cat_id).length }}</span>
          </div>

          <div class="category-content six-col">
            <div
              v-for="topic in getCategoryTopics(category.cat_id)"
              :key="topic.id"
              class="topic-item"
              :class="{ dragging: draggedItem === topic.id }"
              draggable="true"
              @dragstart="startDrag($event, topic)"
              @dragend="stopDrag"
            >
              <div class="topic-title">{{ topic?.new_title || topic.title }}</div>
              <div class="topic-meta">
                <a :href="createTopicLink(topic)" class="open-topic"><span class="topic-id">Open</span></a>
                <span class="topic-date">{{ formatDate(topic.date) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Categories containers -->
        <div
          v-for="category in categories.filter((category) => category.title !== 'Отклонённые' && category.title !== 'В Работе')"
          :key="category.cat_id"
          class="category-container"
          :class="{ 'drop-zone-active': dragOverCategory === category.cat_id }"
          @dragover.prevent="handleDragOver(category.cat_id)"
          @dragleave="handleDragLeave"
          @drop="handleDrop(category.cat_id)"
        >
          <div class="category-header">
            <input
              v-model="category.title"
              class="category-title"
              :placeholder="`Категория ${category.cat_id}`"
              @blur="saveCategories"
            />
            <span class="category-count">{{ getCategoryTopics(category.cat_id).length }}</span>
          </div>

          <div class="category-content" style="display: grid; grid-template-columns: 1fr 1fr 1fr;">
            <div
              v-for="topic in getCategoryTopics(category.cat_id)"
              :key="topic.id"
              class="topic-item"
              :class="{
      dragging: draggedItem === topic.id,
      'drag-over': dragOverElement === topic.id,
      'left-red': topic?.pFlags?.closed === true
    }"
              draggable="true"
              @dragstart="startDrag($event, topic)"
              @dragend="stopDrag"
              @dragover="handleElementDragOver($event, topic, category.cat_id)"
              @drop="handleElementDrop($event, topic, category.cat_id)"
            >
              <div class="topic-title">{{ topic?.new_title || topic.title }}</div>
              <div class="topic-meta">
                <a :href="createTopicLink(topic)" class="open-topic"><span class="topic-id">Open</span></a>
                <span class="topic-date">{{ formatDate(topic.date) }}</span>
              </div>
            </div>
          </div>



        </div>

        <!-- Uncategorized topics -->
        <div class="uncategorized-topics">

          <div class="category-header">
            <span
              class="category-title"
            >В Ожидании</span>
            <span class="category-count">{{ getUncategorizedTopics().length }}</span>
          </div>

          <div class="topics-grid">
            <div
              v-for="topic in getUncategorizedTopics()"
              :key="topic.id"
              class="topic-item uncategorized"
              :class="{ dragging: draggedItem === topic.id, 'left-red': topic?.pFlags?.closed === true}"
              draggable="true"
              @dragstart="startDrag($event, topic)"
              @dragend="stopDrag"
            >
              <div class="topic-title">{{ topic?.new_title || topic.title }}</div>
              <div class="topic-meta">
                <a :href="createTopicLink(topic)" class="open-topic"><span class="topic-id">Open</span></a>
                <span class="topic-date">{{ formatDate(topic.date) }}</span>
              </div>
            </div>
          </div>
        </div>


        <div
          v-for="category in categories.filter(category => category.title === 'Отклонённые')"
          :key="category.cat_id"
          class="category-container uncategorized-topics"
          :class="{ 'drop-zone-active': dragOverCategory === category.cat_id }"
          @dragover.prevent="handleDragOver(category.cat_id)"
          @dragleave="handleDragLeave"
          @drop="handleDrop(category.cat_id)"
        >
          <div class="category-header">
            <input
              v-model="category.title"
              class="category-title"
              :placeholder="`Категория ${category.cat_id}`"
              @blur="saveCategories"
            />
            <span class="category-count">{{ getCategoryTopics(category.cat_id).length }}</span>
          </div>

          <div class="category-content six-col">
            <div
              v-for="topic in getCategoryTopics(category.cat_id)"
              :key="topic.id"
              class="topic-item"
              :class="{ dragging: draggedItem === topic.id }"
              draggable="true"
              @dragstart="startDrag($event, topic)"
              @dragend="stopDrag"
            >
              <div class="topic-title">{{ topic?.new_title || topic.title }}</div>
              <div class="topic-meta">
                <a :href="createTopicLink(topic)" class="open-topic"><span class="topic-id">Open</span></a>
                <span class="topic-date">{{ formatDate(topic.date) }}</span>
              </div>
            </div>
          </div>

        </div>



      </div>

      <!-- Resize handle -->
      <div
        class="resize-handle"
        @mousedown="startResize"
      >
        <div class="resize-line"></div>
        <span class="resize-text">Потяните для изменения размера</span>
      </div>
    </div>

    <div v-if="Object.keys(categorizedTopics).length > 0" class="positions-output" style="display: none;">
      <h3>🎯 Текущие категории (скопируйте для использования по умолчанию):</h3>
      <pre>{{ JSON.stringify({ categories, categorizedTopics }, null, 2) }}</pre>
    </div>

  </div>
</template>

<script setup>
import {ref, reactive, onUnmounted, onMounted} from 'vue'
import {topicsSrc} from '../composables/topics'
import {positionsSrc} from '../composables/positions'

// Реактивные данные
const topics = ref([])
const positions = reactive(positionsSrc)
const loading = ref(false)
const error = ref('')
const draggedItem = ref(null)
const draggedTopic = ref(null)
const dragOverCategory = ref(null)
const workspace = ref(null)
const fileInput = ref(null)
const workspaceHeight = ref(800)
const isResizing = ref(false)
const dragOverElement = ref(null)
const autoScrollInterval = ref(null)

const defCat = [
  { cat_id: 1, title: 'Системные' },
  { cat_id: 2, title: 'Важные & Сложные & Срачные & Нужные' },
  { cat_id: 3, title: 'Бэклог' },
  { cat_id: 4, title: 'Завершенные' },
  { cat_id: 5, title: 'Баги' },
  { cat_id: 6, title: 'Дальний Ящик' },
  { cat_id: 7, title: 'В Работе' },
  { cat_id: 8, title: 'Отклонённые' },
];

function convertToMessageId(apiId) {
  // Для больших ID (обычно > 2^31) нужно применить битовые операции
  if (apiId > 2147483647) { // 2^31 - 1
    return apiId - 4294967296; // 2^32
  }
  return apiId;
}

function createTopicLink(topicData) {
  const channelId = topicData.peer.channel_id;
  const apiId = topicData.id;
  const messageId = convertToMessageId(apiId);

  // return `https://t.me/c/${channelId}/${messageId}`;
  return `tg://privatepost?channel=${channelId}&post=${messageId}`;
}

// // Ваш пример:
// const apiId = 4294967415;
// const messageId = convertToMessageId(apiId);
// console.log(messageId); // 119
//
// const link = `https://t.me/c/2632429440/${messageId}`;
// console.log(link); // https://t.me/c/2632429440/119



const categoryOrder = reactive({"1":[4294967297,4294967529,4294967320,4294967317,4294967312],"3":[4294967621,4294967382]}) // Для хранения порядка элементов внутри категорий

const categories = ref(defCat)

const categorizedTopics = reactive({
  "4294967297": 1,
  "4294967317": 1,
  "4294967529": 1,
  "4294967621": 2,
  "4294967312": 1,
  "4294967413": 2,
  "4294967320": 1,
  "4294967581": 3,
  "4294967382": 4,
  "4294967548": 3,
  "4294967598": 1,
  "4294967533": 4,
  "4294967538": 4,
  "4294967527": 4,
  "4294967315": 4,
  "4294967483": 4,
  "4294967464": 4,
  "4294967488": 4,
  "4294967393": 4,
  "4294967306": 4,
  "4294967326": 4,
  "4294967353": 4,
  "4294967347": 4,
  "4294967363": 4,
  "4294967310": 4,
  "4294967408": 4,
  "4294967536": 7,
  "4294967437": 2,
  "4294967301": 2,
  "4294967303": 2,
  "4294967328": 2,
  "4294967330": 2,
  "4294967351": 2,
  "4294967389": 2,
  "4294967354": 2,
  "4294967343": 3,
  "4294967462": 3,
  "4294967349": 5,
  "4294967460": 8,
  "4294967356": 2,
  "4294967524": 3,
  "4294967474": 3,
  "4294967345": 3,
  "4294967601": 3,
  "4294967540": 6,
  "4294967505": 5,
  "4294967456": 5,
  "4294967503": 2,
  "4294967391": 3,
  "4294967493": 3,
  "4294967472": 2,
  "4294967518": 2
})

// Загрузка JSON файлов
const loadJsonFiles = async (event) => {
  const files = Array.from(event.target.files)
  if (files.length === 0) return

  loading.value = true
  error.value = ''

  try {
    const allTopics = []

    for (const file of files) {
      const text = await file.text()
      const data = JSON.parse(text).messages

      if (Array.isArray(data)) {
        allTopics.push(...data)
      } else {
        throw new Error(`Файл ${file.name} не содержит массив`)
      }
    }

    topics.value = allTopics.filter(topic => topic.type === 'service' && (!!topic?.new_title || !!topic?.title))
    initializePositions()

  } catch (err) {
    error.value = `Ошибка загрузки файлов: ${err.message}`
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  try {
    const allTopics = []
    const data = topicsSrc

    if (Array.isArray(data)) {
      allTopics.push(...data)
    } else {
      throw new Error(`Данные не содержат массив`)
    }

    topics.value = allTopics.filter(topic => !!topic?.new_title || !!topic?.title)
    initializePositions()
    loadSavedData()

  } catch (err) {
    error.value = `Ошибка загрузки данных: ${err.message}`
  } finally {
    loading.value = false
  }
})

// Load saved data from localStorage
// const loadSavedData = () => {
//   try {
//     const savedCategories = localStorage.getItem('forum-categories')
//     const savedCategorizedTopics = localStorage.getItem('forum-categorized-topics')
//     const savedWorkspaceHeight = localStorage.getItem('forum-workspace-height')
//
//     if (savedCategories) {
//       categories.value = JSON.parse(savedCategories)
//     }
//     if (savedCategorizedTopics) {
//       Object.assign(categorizedTopics, JSON.parse(savedCategorizedTopics))
//     }
//     if (savedWorkspaceHeight) {
//       workspaceHeight.value = parseInt(savedWorkspaceHeight)
//     }
//   } catch (err) {
//     console.warn('Ошибка загрузки сохраненных данных:', err)
//   }
// }
const loadSavedData = () => {
  try {
    const savedCategories = localStorage.getItem('forum-categories')
    const savedCategorizedTopics = localStorage.getItem('forum-categorized-topics')
    const savedWorkspaceHeight = localStorage.getItem('forum-workspace-height')

    if (savedCategories) {
      categories.value = JSON.parse(savedCategories)
    }
    if (savedCategorizedTopics) {
      Object.assign(categorizedTopics, JSON.parse(savedCategorizedTopics))
    }
    // if (savedWorkspaceHeight) {
    //   workspaceHeight.value = parseInt(savedWorkspaceHeight)
    // }

    loadCategoryOrder() // Добавить эту строку
  } catch (err) {
    console.warn('Ошибка загрузки сохраненных данных:', err)
  }
}

// Save categories
const saveCategories = () => {
  localStorage.setItem('forum-categories', JSON.stringify(categories.value))
}

// Save categorized topics
const saveCategorizedTopics = () => {
  localStorage.setItem('forum-categorized-topics', JSON.stringify(categorizedTopics))
}

// Save workspace height
const saveWorkspaceHeight = () => {
  localStorage.setItem('forum-workspace-height', workspaceHeight.value.toString())
}

// Инициализация начальных позиций
const initializePositions = () => {
  topics.value.forEach((topic, index) => {
    if (!positions[topic.id]) {
      const row = Math.floor(index / 4)
      const col = index % 4
      positions[topic.id] = {
        x: 50 + col * 300,
        y: 50 + row * 120,
        borderLeftColor: 'red !important',
      }
    }
  })
}

// Get topics for specific category
// const getCategoryTopics = (categoryIndex) => {
//   return topics.value.filter(topic => categorizedTopics[topic.id] === categoryIndex)
// }
const getCategoryTopics = (categoryIndex) => {
  const categoryTopics = topics.value.filter(topic => categorizedTopics[topic.id] === categoryIndex)

  // Если есть сохраненный порядок для этой категории, используем его
  if (categoryOrder[categoryIndex]) {
    const orderedTopics = []
    const remainingTopics = [...categoryTopics]

    // Сначала добавляем топики в сохраненном порядке
    categoryOrder[categoryIndex].forEach(topicId => {
      const topic = remainingTopics.find(t => t.id === topicId)
      if (topic) {
        orderedTopics.push(topic)
        remainingTopics.splice(remainingTopics.indexOf(topic), 1)
      }
    })

    // Затем добавляем оставшиеся топики
    orderedTopics.push(...remainingTopics)
    return orderedTopics
  }

  return categoryTopics
}

// Get uncategorized topics
const getUncategorizedTopics = () => {
  return topics.value.filter(topic => categorizedTopics[topic.id] === undefined)
}

// Форматирование даты
const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000)
  const formatted = date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long'
  })
  return formatted
}

// Drag and drop handlers
// const startDrag = (event, topic) => {
//   draggedItem.value = topic.id
//   draggedTopic.value = topic
//   event.dataTransfer.effectAllowed = 'move'
//   event.dataTransfer.setData('text/plain', topic.id)
// }
const startDrag = (event, topic) => {
  draggedItem.value = topic.id
  draggedTopic.value = topic
  event.dataTransfer.effectAllowed = 'move'
  event.dataTransfer.setData('text/plain', topic.id)

  // Запуск автопрокрутки
  autoScrollInterval.value = setInterval(() => {
    const mouseY = event.clientY || window.lastMouseY
    const windowHeight = window.innerHeight
    const scrollSpeed = 5

    if (mouseY < 100) {
      window.scrollBy(0, -scrollSpeed)
    } else if (mouseY > windowHeight - 100) {
      window.scrollBy(0, scrollSpeed)
    }
  }, 16)

  // Отслеживание позиции мыши
  document.addEventListener('dragover', trackMousePosition)
}

const trackMousePosition = (event) => {
  window.lastMouseY = event.clientY
}

const handleDragOver = (categoryIndex) => {
  dragOverCategory.value = categoryIndex
}

const handleDragLeave = () => {
  dragOverCategory.value = null
}

const handleDrop = (categoryIndex) => {
  if (draggedTopic.value) {
    categorizedTopics[draggedTopic.value.id] = categoryIndex
    saveCategorizedTopics()
  }
  dragOverCategory.value = null
}

// const stopDrag = () => {
//   draggedItem.value = null
//   draggedTopic.value = null
//   dragOverCategory.value = null
// }

const stopDrag = () => {
  draggedItem.value = null
  draggedTopic.value = null
  dragOverCategory.value = null
  dragOverElement.value = null

  // Очистка автопрокрутки
  if (autoScrollInterval.value) {
    clearInterval(autoScrollInterval.value)
    autoScrollInterval.value = null
  }

  document.removeEventListener('dragover', trackMousePosition)
}

const handleElementDragOver = (event, topic, categoryId) => {
  event.preventDefault()
  event.stopPropagation()

  if (draggedTopic.value && draggedTopic.value.id !== topic.id) {
    dragOverElement.value = topic.id
    dragOverCategory.value = categoryId
  }
}

const handleElementDrop = (event, targetTopic, categoryId) => {
  event.preventDefault()
  event.stopPropagation()

  if (!draggedTopic.value) return

  const draggedTopicId = draggedTopic.value.id
  const targetTopicId = targetTopic.id

  // Если перетаскиваем в ту же категорию - меняем порядок
  if (categorizedTopics[draggedTopicId] === categoryId) {
    const categoryTopics = getCategoryTopics(categoryId)
    const draggedIndex = categoryTopics.findIndex(t => t.id === draggedTopicId)
    const targetIndex = categoryTopics.findIndex(t => t.id === targetTopicId)

    if (draggedIndex !== -1 && targetIndex !== -1 && draggedIndex !== targetIndex) {
      // Создаем новый порядок
      const newOrder = categoryTopics.map(t => t.id)

      // Удаляем перетаскиваемый элемент
      newOrder.splice(draggedIndex, 1)

      // Вставляем в новую позицию
      const insertIndex = draggedIndex < targetIndex ? targetIndex - 1 : targetIndex
      newOrder.splice(insertIndex, 0, draggedTopicId)

      categoryOrder[categoryId] = newOrder
      saveCategoryOrder()
    }
  } else {
    // Перетаскиваем в другую категорию
    categorizedTopics[draggedTopicId] = categoryId
    saveCategorizedTopics()
  }

  dragOverElement.value = null
  dragOverCategory.value = null
}

// 8. Добавить функции сохранения и загрузки порядка категорий
const saveCategoryOrder = () => {
  localStorage.setItem('forum-category-order', JSON.stringify(categoryOrder))
}

const loadCategoryOrder = () => {
  try {
    const savedOrder = localStorage.getItem('forum-category-order')
    if (savedOrder) {
      Object.assign(categoryOrder, JSON.parse(savedOrder))
    }
  } catch (err) {
    console.warn('Ошибка загрузки порядка категорий:', err)
  }
}

// Resize functionality
const startResize = (event) => {
  isResizing.value = true
  document.addEventListener('mousemove', handleResize)
  document.addEventListener('mouseup', stopResize)
  event.preventDefault()
}

const handleResize = (event) => {
  if (!isResizing.value) return

  const containerRect = document.querySelector('.workspace-wrapper').getBoundingClientRect()
  const newHeight = event.clientY - containerRect.top
  // workspaceHeight.value = Math.max(400, Math.min(2000, newHeight))
}

const stopResize = () => {
  isResizing.value = false
  saveWorkspaceHeight()
  document.removeEventListener('mousemove', handleResize)
  document.removeEventListener('mouseup', stopResize)
}

// Сброс позиций
// const resetPositions = () => {
//   Object.keys(positions).forEach(key => delete positions[key])
//   Object.keys(categorizedTopics).forEach(key => delete categorizedTopics[key])
//   categories.value = defCat;
//   workspaceHeight.value = 800
//   initializePositions()
//   saveCategories()
//   saveCategorizedTopics()
//   saveWorkspaceHeight()
// }
const resetPositions = () => {
  Object.keys(positions).forEach(key => delete positions[key])
  Object.keys(categorizedTopics).forEach(key => delete categorizedTopics[key])
  Object.keys(categoryOrder).forEach(key => delete categoryOrder[key])
  categories.value = defCat;
  // workspaceHeight.value = 800
  initializePositions()
  saveCategories()
  saveCategorizedTopics()
  saveCategoryOrder()
  saveWorkspaceHeight()
}

// Экспорт позиций
const exportPositions = () => {
  const dataStr = JSON.stringify({
    categories: categories.value,
    categorizedTopics,
    workspaceHeight: workspaceHeight.value
  }, null, 2)
  const dataBlob = new Blob([dataStr], { type: 'application/json' })
  const url = URL.createObjectURL(dataBlob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'forum-topics-categories.json'
  link.click()
  URL.revokeObjectURL(url)
}

// Очистка обработчиков при размонтировании
onUnmounted(() => {
  document.removeEventListener('mousemove', handleResize)
  document.removeEventListener('mouseup', stopResize)
})
</script>

<style scoped>
.draggable-topics-container {
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  border-radius: 20px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  color: white;
}

.header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  //text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.controls {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.btn {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.btn:hover {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading {
  text-align: center;
  color: white;
  font-size: 1.2rem;
  margin: 50px 0;
}

.workspace-wrapper {
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.workspace {
  padding: 20px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto) auto;
  gap: 20px;
}

.category-container {
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 15px;
  transition: all 0.3s ease;
  //min-height: 200px;
}

.category-container.drop-zone-active {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.02);
}

.category-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.category-title {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  flex: 1;
  color: #333;
}

.left-red {
  border-left-color: red !important;
}

.category-title:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.category-count {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
}

.category-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  //max-height: 300px;
  //overflow-y: auto;
  overflow: visible;
}

.uncategorized-topics {
  grid-column: 1 / -1;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 15px;
  margin-top: 20px;
}

.uncategorized-topics h3 {
  color: white;
  margin-bottom: 15px;
  text-align: center;
}

.topics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
}

.topic-item {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 16px 20px;
  cursor: grab;
  user-select: none;
  transition: all 0.2s ease;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  border: 2px solid transparent;
  backdrop-filter: blur(10px);
  border-left: 4px solid #4ECDC4;
}

.topic-item.uncategorized {
  border-left-color: #ccc;
}

.topic-item:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
}

.topic-item.dragging {
  opacity: 0.5;
  transform: rotate(2deg) scale(1.05);
  cursor: grabbing;
}

.topic-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
}

.topic-meta {
  font-size: 0.8rem;
  color: #666;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic-id {
  background: #26a5e5;
  padding: 2px 8px;
  border-radius: 8px;
  font-family: monospace;
}

.topic-date {
  font-size: 0.75rem;
}

.resize-handle {
  background: rgba(255, 255, 255, 0.1);
  height: 30px;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s ease;
}

.resize-handle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.resize-line {
  width: 40px;
  height: 4px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
}

.resize-text {
  position: absolute;
  right: 15px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8rem;
}

.positions-output {
  margin-top: 30px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  padding: 20px;
  backdrop-filter: blur(10px);
}

.positions-output h3 {
  margin-bottom: 15px;
  color: #333;
}

.positions-output pre {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 0.9rem;
  border: 1px solid #e9ecef;
  white-space: pre-wrap;
}

.error {
  background: rgba(255, 59, 48, 0.9);
  color: white;
  padding: 15px;
  border-radius: 12px;
  margin: 20px 0;
  text-align: center;
}

.topic-item.drag-over {
  border-top: 3px solid #4ECDC4;
  transform: translateY(-2px);
}

.open-topic {
  color: white;
  font-weight: bold;
}

.six-col {
  display: grid;
  grid-template-columns: repeat(6, 1fr) !important;
}
</style>